import { useTranslation } from 'react-i18next'
import './Footer.css'

export const Footer = () => {
    const { t } = useTranslation()
    const story = t('story', { returnObjects: true })

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    return (
        <footer className='site-footer'>
            <div className='footer-inner'>

                {/* Brand column */}
                <div className='footer-brand'>
                    <div className='footer-logo'>
                        <span className='footer-flame'>🔥</span>
                        <span className='footer-brand-name'>$LIGHTER</span>
                    </div>
                    <p className='footer-tagline'>
                        {story.footerTagline}
                    </p>
                </div>

                {/* Links column */}
                <div className='footer-links-group'>
                    <h4 className='footer-col-title'>{story.footerCommunity}</h4>
                    <a href='https://t.me/lighter_coin' target='_blank' rel='noopener noreferrer' className='footer-link'>
                        {story.footerTelegram}
                    </a>
                    <a href='https://instagram.com/lighter_coin' target='_blank' rel='noopener noreferrer' className='footer-link'>
                        {story.footerInstagram}
                    </a>
                    <a href='https://x.com/_lighter_coin' target='_blank' rel='noopener noreferrer' className='footer-link'>
                        {story.footerTwitter}
                    </a>
                    <a href='https://tiktok.com/@lighter_coin' target='_blank' rel='noopener noreferrer' className='footer-link'>
                        {story.footerTikTok}
                    </a>
                </div>

                <div className='footer-links-group'>
                    <h4 className='footer-col-title'>{story.footerBuy}</h4>
                    <a
                        href='https://t.me/blum/app?startapp=memepadjetton_LIGHTER_lfviO-ref_UsG1k7XbXa'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='footer-cta-link'>
                        {story.footerBlumDex}
                    </a>
                    <a
                        href='https://app.ston.fi/swap?chartVisible=true&chartInterval=1w&ft=USD₮&tt=EQDheHEbyYsL5brD3uRxNgpxtH5KoUqdP6LC98iMhBNHyh0V&fa=%225%22&referral_address=UQB1ApXMxxg4Ddzx3XXxa4keJ-IgBDJq9sLWHdfcoVHCtfK5'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='footer-cta-link'>
                        {story.footerStonFi}
                    </a>
                </div>

            </div>

            <div className='footer-bottom'>
                <p className='footer-copy'>{(() => { const y = new Date().getFullYear(); return `© ${y === 2025 ? '2025' : `2025\u2013${y}`} $LIGHTER. ${story.footerAllRightsReserved}`; })()}</p>
                <button
                    className='footer-back-top'
                    onClick={scrollToTop}
                    aria-label={story.footerBackToTop}>
                    {story.footerBackToTop}
                </button>
            </div>
        </footer>
    )
}
